import axios from "axios";

export const api = axios.create({
    baseURL: "https://api.evoreview.ru",
    withCredentials: true
})
